import { render, staticRenderFns } from "./MapHighlightDeptosAirea.vue?vue&type=template&id=5678c54e"
import script from "./MapHighlightDeptosAirea.vue?vue&type=script&lang=js"
export * from "./MapHighlightDeptosAirea.vue?vue&type=script&lang=js"
import style0 from "./MapHighlightDeptosAirea.vue?vue&type=style&index=0&id=5678c54e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports